<template>
  <!--  <iframe ref="iframe" width="100%" height="758px" frameborder="0"></iframe>-->
  <div class="introduce">
    <iframe
      id="Iframe"
      ref="iframe"
      width="100%"
      height="100%"
      frameborder="0"
      scrolling="no"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "18introduce",
  data() {
    return {
      url:
        "https://www.meipian5.cn/35oqwliz?share_depth=2&user_id=ohbsluLrawk3W4eRNuxGL18KmhtA&sharer_id=ojq1tt1aoBgi5XRvcYNRmEO5fqKo&first_share_to=timeline&s_uid=72850201&first_share_uid=72850201&share_source=timeline ",
      // url: "http://172.20.2.2:8380/oa/zrpage/login.jsp",
    };
  },
  mounted() {
    const oIframe = document.getElementById("Iframe");
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.height = Number(deviceHeight) - 156 + "px";
    this.$refs.iframe.contentWindow.location.replace(this.url);
    // window.location.href = this.url;
  },
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
